<template>
	<div class="unstyledwrapper">
		<div :class="'renderItem book'+controlid" :id="'book'+controlid">
			<div class="book-action-mobile">
				<div class="img-area">
					<!-- <img
						:src="'https://bayer-cardio-lib.s3.eu-west-2.amazonaws.com/' + $attrs.bookDOI + '/thumbnails/1.jpg'"
						alt="Book Cover"
						class="book-image"
					/> -->
					<img
						:src=" signedHost + '/.netlify/functions/api/thumbnails/' + $attrs.bookDOI + '/thumbnails/1.jpg'"
						alt="Book Cover"
						class="book-image"
					/>
				</div>
				<div class="button-area-line">

					<a
						target="_blank"
						@click="show_dialog('modal' + controlid, 'navigate' + controlid, $attrs.bookDOI)"
						class="open"
					>Open Book</a>

				</div>
			</div>

			<div class="flex book-content" key="$attrs._id">
				<div class="mobile-hide">
					<!--<img :src="'https://bayer-cardio-bucket.s3.eu-west-2.amazonaws.com/' + $attrs.bookDOI + '/thumbnails/1.jpg'" alt="Book Cover" class="book-image" /> -->
					<img
						:src=" signedHost + '/.netlify/functions/api/thumbnails/' + $attrs.bookDOI + '/thumbnails/1.jpg'"
						alt="Book Cover"
						class="book-image"
					/>
				</div> 
				<div class="column justify-top ml20 infopanel">
					<h1>{{ $attrs.bookTitle }}</h1>
					<div class="bookPanelDescription">
						<span class="bookLabel">Published:&nbsp;</span>
						<span class="bookInfo">{{ $attrs.bookPublishedYear }}</span>
					</div>
					<!-- <div class="bookPanelDescription">
						<span class="bookLabel">Editors:&nbsp;</span>
						<span v-for="(editor,index) in Array.isArray($attrs.bookEditors) ? $attrs.bookEditors : [$attrs.bookEditors]" class="bookInfo" :key="editor">
							{{ editor }},{{ index }}
						</span>
					</div> -->
					<!-- <div class="bookPanelDescription">
						<span class="bookLabel">Editors:&nbsp;</span>
						<span v-for="(editor,index) in Array.isArray($attrs.bookEditors) ? $attrs.bookEditors : [$attrs.bookEditors]" class="bookInfo" :key="index">
							<span v-for="(editorGivenNameComponent, indexx) in Array.isArray(editor.EditorName)?['X'] : ['Y']" :key="indexx">{{editorGivenNameComponent}} {{ index }}</span>
						</span>
					</div> -->

					<div v-if="$attrs.bookAuthors && convertNonArrayToArray($attrs.bookAuthors)[0] != null " class="bookPanelDescription">
						<span class="bookLabel">Authors:&nbsp;</span>
						<span v-for="(author,index) in convertNonArrayToArray($attrs.bookAuthors.Author)" class="bookInfo" :key="index">
							{{AuthorNameParser(author)}}
							<span v-if="index < convertNonArrayToArray($attrs.bookAuthors.Author).length-1">, </span>
						</span>
					</div>
					<div v-if="$attrs.bookEditors && convertNonArrayToArray($attrs.bookEditors).length > 0 && convertNonArrayToArray($attrs.bookEditors)[0] != null" class="bookPanelDescription">
						<span class="bookLabel">Editors:&nbsp;</span>
						<span v-for="(editor,index) in convertNonArrayToArray($attrs.bookEditors)" class="bookInfo" :key="index">
							{{EditorNameParser(editor)}}
							<span v-if="index < convertNonArrayToArray($attrs.bookEditors).length-1">, </span>
						</span>
					</div>
					<div class="bookPanelDescription">
						<span class="bookLabel">&nbsp;</span>
						<span class="bookInfo"><div type="text" v-html="decode($attrs.bookAboutText)"></div></span>
					</div>
					<div class="button-area-line mobile-hide">
						<!-- <a
							target="_blank"
							name="mybutton"
							id="myButton"
							@click="show_dialog('modal' + controlid,'navigate' + controlid, $attrs.chapterDOI)"
							class="open"
						>Open This Chapter</a> -->
						<a
							target="_blank"
							@click="show_dialog('modal' + controlid,'navigate' + controlid, $attrs.bookDOI)"
							class="open"
						>Open Book</a>
						<!-- <a
							class="order"
							v-bind:class="{ hideMe: $attrs.bookFlaggedForOrderable=='No'}"
							@click="orderBook($attrs.bookDOI)"
						>Order Full Book</a> -->
					</div>
				</div>
			</div>
			<!-- Modal -->
			<div class="modal fade"  :id="'modal'+this.controlid" tabindex="-1" role="dialog" aria-labelledby="dialog_confirm_mapLabel" aria-hidden="true">
				<div class="modal-dialog" >
					<div class="modal-content">
						<div class="modal-body text-center">
							<p class="text-center pt-4">You are leaving this site to navigate to an external website. We invite you to read its Privacy Policy</p>
						</div>
						<div class="modal-footer justify-content-center align-items-center">
							<button type="button" :id="'navigate'+this.controlid" class="btn btn-primary" data-dismiss="modal" @click="openBook()">I AGREE </button>
							<button type="button" class="btn btn-cancel" data-dismiss="modal">CANCEL</button>
						</div>
					</div>
					<!-- /.modal-content -->
				</div>
				<!-- /.modal-dialog -->
			</div>
			<!-- /.modal -->
		</div>
	</div>
</template>
<script>
import {decode} from 'html-entities';

export default {
  data() {
    return {
      props: ['bookprops'],
      //item: {},
      checked: false,
	  controlid: this._uid,
	  bookId: null,
	  orderBookConfiguration: {
		  receivedAddress: 'simon.fry@springer.com',
		  subject: 'eLibrary order',
		  body: this.$attrs.bookTitle,
      cc: 'rene.molenaar@springer.com'
	  },

	//signedHost: process.env.NODE_ENV === "development" ? "http://localhost:9000" : ""
	signedHost: process.env.NODE_ENV === "development" ? "http://localhost:9000" : ""

	//   chapterUrl:'https://novartis-derm-lib.s3.eu-west-2.amazonaws.com/' + $attrs.chapterDOI + '/index.html',
	//   bookUrl: 'https://novartis-derm-lib.s3.eu-west-2.amazonaws.com/' + $attrs.bookDOI + '/index.html'
	}
  },
  mounted () {
	// console.log(this.$attrs, 'BookDisplayPanel/vue')
	// console.log("NODE_ENV", process.env.NODE_ENV);
  },
  methods: {

	convertNonArrayToArray: function (value) {
		return Array.isArray(value) ? value : [value]
		//return "BOO";
	},

	EditorNameParser: function (value) {
		// console.log(value);
		// console.log(JSON.stringify(value));
		if (value && "EditorName" in value && value != null && value != undefined && value != {}){
			const prefix = "Prefix" in value.EditorName ? value.EditorName.Prefix : "";
			const givenName = "GivenName" in value.EditorName ? Array.isArray(value.EditorName.GivenName)? value.EditorName.GivenName.join(" ") :value.EditorName.GivenName : "";
			const familyName = "FamilyName" in value.EditorName ? value.EditorName.FamilyName : "";
			return (prefix + " " + givenName + " " + familyName)
		}
		else {
			return "";
		}
	},

	AuthorNameParser: function (value) {
		// console.log(value);
		// console.log(JSON.stringify(value));
		console.log("AuthorName" in value);
		if (value && "AuthorName" in value && value != null && value != undefined && value != {}){
			const prefix = "Prefix" in value.AuthorName ? value.AuthorName.Prefix : "";
			const givenName = "GivenName" in value.AuthorName ? Array.isArray(value.AuthorName.GivenName)? value.AuthorName.GivenName.join(" ") :value.AuthorName.GivenName : "";
			const familyName = "FamilyName" in value.AuthorName ? value.AuthorName.FamilyName : "";
			return (prefix + " " + givenName + " " + familyName)
		}
		else {
			return "";
		}
	},

	decode (value) {
		let decoded = value
		if(value){ decoded = decode(value) }
		return decoded
    },
	serializerQueryString: function (obj) {
		var str = [];
		for (var p in obj)
			if (Object.prototype.hasOwnProperty.call(obj, p)) {
				str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
			}
		return str.join("&");
	},
	openUrl: function(url){
		window.open(url)
	},
	buildingOrderBookEmail (bookTitle, bookDOI) {
		var body = 'Dear Sir/ Madam,\n\n';
		body = body + 'Many thanks for your book request via eLibrary Dermatology.\n';
		body = body + 'In order to properly process your request, we kindly request you to communicate the complete shipping address.\n\n';
		body = body + 'Requested publication:\n';
		body = body + bookTitle + '\n\n';
		body = body + 'Delivery Address:\nPlease reply to this email confirmation by sending your detailed shipping address to deliver this special edition publication.\n';
    body = body + 'Please also provide us your email address for any future production and delivery updates.\n\n';
		body = body + 'As soon as your publication has been produced and handled you will receive an email confirmation with the potential delivery date.\n';
		body = body + 'We will handle your book request with the utmost.\n\n';
		body = body + 'Kind regards,\n';
		body = body + 'Springer Healthcare eLibrary\n\n';
    body = body + `Book Code: ${btoa(bookDOI)}`
		return body
	},
  orderBook: function(){
		// Gtm track event
		const category = 'Button press'
		const action = 'Book Order'
		const label = this.$attrs.bookTitle
		const value = null
		// this.gtmTrackEvent(category, label, value, action)

		// Make an order
		var emailBody = this.buildingOrderBookEmail(this.$attrs.bookTitle, this.$attrs.bookDOI)
		var queryParamters = {
			subject: this.orderBookConfiguration.subject,
			body: emailBody,
      cc: this.orderBookConfiguration.cc
		}
		var queryString = this.serializerQueryString(queryParamters);
		const mailtoUrl = 'mailto:' + this.orderBookConfiguration.receivedAddress + '?' + queryString
		window.location.href = mailtoUrl
		// window.open(mailtoUrl, 'mail')
		// window.open(mailtoUrl)
	},
	openBook: function(){
		document.cookie = `BookID=${this.bookId};samesite=none;secure=true`;
		window.open(this.navigateTo)
	},
	gtmTrackEvent (category, label, value, action='click', event=null) {
		this.$gtm.trackEvent({
			event: event, // Event type [default = 'interaction'] (Optional)
			category: category,
			action: action,
			label: label,
			value: value,
		})
	},
    postAnalyticsEventToParent(event) {
        window.parent.postMessage({
			dataType: 'analytics',
			data: event
		}, '*');
	},
	trackGtmEvent (bookId) {
		// console.log(this.$attrs)
		if (bookId === this.$attrs.bookDOI) {
			const category = 'Button press'
			const label = this.$attrs.bookTitle
			const action = 'Open Book - ' + this.$attrs.bookDOI
			const value = null

			// Todo: event track for order a book
			// this.gtmTrackEvent(category, label, value, action)
            this.postAnalyticsEventToParent({
                event: 'gaGenericEvent',
                eventCategory: 'elibraryBookOpened (local)',
                eventAction: this.$attrs.bookDOI,
                eventLabel: this.$attrs.bookTitle,
            });
		} else if (bookId === this.$attrs.chapterDOI) {
			const category = 'Button press'
			const label = this.$attrs.chapterTitle
			const action = 'Open Chapter - ' + this.$attrs.chapterDOI
			const value = null

			// Todo: event track for order a chapter
			// this.gtmTrackEvent(category, label, value, action)
            this.postAnalyticsEventToParent({
                event: 'gaGenericEvent',
                eventCategory: 'elibraryChapterOpened (local)',
                eventAction: this.$attrs.bookDOI,
                eventLabel: `${this.$attrs.bookTitle} - ${this.$attrs.chapterTitle} (${this.$attrs.chapterDOI})`,
            });
		}
	},
	show_dialog: function(divToCover, actionButtonId, bookId){
		$('#' + divToCover).modal("show");
		$('.modal-backdrop').appendTo('#book' + this.controlid);
		// this.navigateTo = url
		this.bookId = bookId;
		this.trackGtmEvent(bookId)
		const metadataQueryString = `?bookTitle=${this.$attrs.bookTitle}`
		this.navigateTo = `${this.signedHost}/.netlify/functions/api/open/${bookId}${metadataQueryString}`;
		//removing body classes to able click events
        $('body').removeClass("modal-open")
	},
	mounted () {
    	this.controlid = this._uid
  	}

  },
  watch: {
	  $attrs: {
		  deep: true,
		  handler (newValue, oldValue) {
			//   console.log(newValue);
		  }
	  }
  }
};
</script>

<style scoped>
.order {
	cursor: pointer;
}
</style>
